module.exports = __webpack_public_path__ + "static/img/env11.bceac92.png";


//////////////////
// WEBPACK FOOTER
// ./src/module/technology/images/env11.png
// module id = 104
// module chunks = 4